import '@ver-uds/styles';
import './globals.scss';
import './App.scss';

import { Banner, BannerExtension, SkipNav } from '@ver-uds/uswds-react';
import React, { FC } from 'react';

import { AccountProvider } from './context/Account/AccountContext';
import Header from './components/Header/Header';
import PageFooter from './components/PageFooter/PageFooter';
import PageRoutes from './PageRoutes';
import SessionHandler from './components/SessionHandler';
import { UserProvider } from './context/User/UserContext';

const App: FC = () => {
  return (
    <UserProvider>
      <AccountProvider>
        <div className="App">
          <div className="main">
            <SkipNav.Anchor />
            <Banner extensionType={BannerExtension.GOV} />
            <div className="usa-overlay" />
            <SessionHandler />
            <Header />
            <PageRoutes />
            <PageFooter />
          </div>
        </div>
      </AccountProvider>
    </UserProvider>
  );
};

export default App;
